export default new Array(12).fill(null).map((v, index) => {
  const value = index + 1;
  return {
    label: `${value}x`,
    value,
  };
});
